var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbuntu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68257 23.8261C8.82096 23.8261 11.3651 21.2819 11.3651 18.1435C11.3651 15.0051 8.82096 12.4609 5.68257 12.4609C2.54417 12.4609 0 15.0051 0 18.1435C0 21.2819 2.54417 23.8261 5.68257 23.8261Z",
    fill: "#E95420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3505 11.3651C32.4889 11.3651 35.0331 8.82097 35.0331 5.68257C35.0331 2.54417 32.4889 0 29.3505 0C26.2121 0 23.668 2.54417 23.668 5.68257C23.668 8.82097 26.2121 11.3651 29.3505 11.3651Z",
    fill: "#E95420"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4996 32.7707C14.4051 31.8934 10.9847 29.279 9.06175 25.5713C7.54711 26.2605 5.84234 26.4701 4.20239 26.1676C6.52944 31.8826 11.4644 36.0333 17.5229 37.3318C18.8518 37.617 20.2065 37.7553 21.5591 37.7467C20.5155 36.3747 19.9342 34.7196 19.8954 32.9954C19.4265 32.9435 18.9598 32.8679 18.5017 32.7685L18.4996 32.7707Z",
    fill: "#E95420"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0715 38.4833C31.2099 38.4833 33.7541 35.9391 33.7541 32.8007C33.7541 29.6623 31.2099 27.1182 28.0715 27.1182C24.9331 27.1182 22.3889 29.6623 22.3889 32.8007C22.3889 35.9391 24.9331 38.4833 28.0715 38.4833Z",
    fill: "#E95420"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9796 30.7136C37.747 28.4859 38.9916 25.852 39.5901 23.054C40.6359 18.173 39.6592 13.0522 36.9109 8.89941C36.2562 10.4421 35.1456 11.745 33.7152 12.6417C35.2493 15.5327 35.716 18.8688 35.0289 22.0774C34.6918 23.6482 34.0977 25.1282 33.2615 26.4808C34.5989 27.5784 35.5431 29.0542 35.9818 30.7157L35.9796 30.7136Z",
    fill: "#E95420"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24386 9.99321C5.38863 9.98457 5.53339 9.98241 5.67599 9.98241C6.25073 9.98241 6.82331 10.0429 7.39157 10.1661C8.3185 10.3648 9.18925 10.7149 9.98654 11.2118C12.5448 7.5322 16.6738 5.324 21.1464 5.24189C21.1702 4.81192 21.2285 4.3841 21.3171 3.96277C21.5785 2.74631 22.1101 1.60764 22.8706 0.633178C15.7231 0.067082 8.77872 3.75535 5.2417 9.99537L5.24386 9.99321Z",
    fill: "#E95420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.e8be94d3f9602806877d245520126338.svg";
export { ForwardRef as ReactComponent };